import apiClient from './Api';
const PREFIX = '/autoedit';

const reFrameHero = postData => {
  return apiClient({
    url: `${PREFIX}/reframehero`,
    method: 'POST',
    data: postData
  });
};

const mProcess = postData => {
  return apiClient({
    url: `${PREFIX}/mprocess`,
    method: 'POST',
    data: postData,
    timeout: 2400000
  });
};

const vehicleDataAutoedit = postData => {
  return apiClient({
    url: `${PREFIX}/vehicle`,
    method: 'POST',
    data: postData
  });
};

const saveAutoeditImages = postData => {
  return apiClient({
    url: `${PREFIX}/save`,
    method: 'POST',
    data: postData
  });
};

const flagImage = postData => {
  return apiClient({
    url: `${PREFIX}/flagimage`,
    method: 'POST',
    data: postData
  });
};

const clearMavis = postData => {
  return apiClient({
    url: `${PREFIX}/finish`,
    method: 'POST',
    data: postData
  });
};

const reprocessBG = postData => {
  return apiClient({
    url: `${PREFIX}/reprocessbg`,
    method: 'GET',
    params: postData
  });
};

const reprocessVDSBG = postData => {
  return apiClient({
    url: `${PREFIX}/reprocessvdsbg`,
    method: 'GET',
    params: postData
  });
};

const getReprocessRatioStatus = postData => {
  return apiClient({
    url: `${PREFIX}/reprocessratiostatus`,
    method: 'POST',
    data: postData
  });
};

const startReprocessRatio = postData => {
  return apiClient({
    url: `${PREFIX}/reprocessratio`,
    method: 'POST',
    data: postData
  });
};

const startGenerate32ExtraImages = postData => {
  return apiClient({
    url: `${PREFIX}/generataedealer32images`,
    method: 'POST',
    data: postData
  });
};

const changeVehicleRatio = postData => {
  return apiClient({
    url: `${PREFIX}/changevehicleratio`,
    method: 'POST',
    data: postData
  });
};

const removeCompositions = postData => {
  return apiClient({
    url: `${PREFIX}/removecompositions`,
    method: 'POST',
    data: postData
  });
};

const AutoEditService = {
  reFrameHero,
  mProcess,
  vehicleDataAutoedit,
  saveAutoeditImages,
  flagImage,
  clearMavis,
  reprocessBG,
  reprocessVDSBG,
  getReprocessRatioStatus,
  startReprocessRatio,
  startGenerate32ExtraImages,
  changeVehicleRatio,
  removeCompositions
};
export default AutoEditService;
